
import React from 'react';
import { Facebook, Instagram, Youtube, Mail, Phone, MapPin, Home } from 'lucide-react';
import { FaTwitter } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
  { name: 'Inicio', href: '#inicio' },
  { name: '¿Qué es la Domótica?', href: '#domotica' },
  { name: 'Soluciones HomeSeer', href: '#homeseer' },
  { name: 'Servicios', href: '#servicios' },
  { name: 'Proyectos', href: '#proyectos' },
  { name: 'Testimonios', href: '#testimonios' },
  { name: 'Comparador', href: '#calculadora' },
  { name: 'Blog', href: 'https://automatiza.me/blog' },
  { name: 'Videos', href: 'https://automatiza.me/videos/' },
  { name: 'Contacto', href: '#contacto' }];


  const services = [
  'Asesoría Experta',
  'Venta de Equipos',
  'Instalación Profesional',
  'Soporte Post-Venta',
  'Mantenimiento',
  'Configuración',
  'Capacitación',
  'Consultoría'];


  const brands = [
  'HomeSeer',
  'Insteon',
  'Fibaro',
  'Lutron',
  'Sonos',
  'Philips Hue',
  'Nest',
  'Ring'];


  const socialLinks = [
  { icon: <Facebook className="w-5 h-5" data-id="and48q4br" data-path="src/components/Footer.tsx" />, href: 'https://www.facebook.com/automatiza.me/', name: 'Facebook' },
  { icon: <Instagram className="w-5 h-5" data-id="l60f9mqc2" data-path="src/components/Footer.tsx" />, href: 'https://www.instagram.com/automatiza.me', name: 'Instagram' },
  { icon: <Youtube className="w-5 h-5" data-id="p626whaur" data-path="src/components/Footer.tsx" />, href: 'https://www.youtube.com/channel/UCYxCsoYcLTkWvUpgBLbWlTA', name: 'YouTube' },
  { icon: <FaTwitter className="w-5 h-5" data-id="q7o949578" data-path="src/components/Footer.tsx" />, href: 'https://x.com/automatizame', name: 'X (Twitter)' }];


  return (
    <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white" data-id="icnvtgnz5" data-path="src/components/Footer.tsx">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16" data-id="4adfa4pi2" data-path="src/components/Footer.tsx">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="flquwqeyp" data-path="src/components/Footer.tsx">
          {/* Company Info */}
          <div className="space-y-4" data-id="8gk8ui5wz" data-path="src/components/Footer.tsx">
            <div className="flex items-center space-x-2" data-id="hma2zd5r5" data-path="src/components/Footer.tsx">
              <img
                src="https://b447696.smushcdn.com/447696/wp-content/uploads/2019/07/logo.png?lossy=1&strip=1&webp=1"
                alt="Automatiza.me"
                className="h-12 w-auto brightness-0 invert" data-id="kescmer88" data-path="src/components/Footer.tsx" />

              <div data-id="u52iq167f" data-path="src/components/Footer.tsx">
                <h3 className="text-2xl font-bold" data-id="3simtouv4" data-path="src/components/Footer.tsx">Automatiza.me</h3>
                <p className="text-sm text-gray-300" data-id="fmthoni7q" data-path="src/components/Footer.tsx">Tu Hogar Inteligente</p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed" data-id="lioyrv4xm" data-path="src/components/Footer.tsx">
              Transformamos tu espacio en un hogar inteligente con soluciones personalizadas, 
              convenientes y seguras. 25 años de experiencia nos respaldan.
            </p>
            <div className="space-y-2" data-id="77ntb475f" data-path="src/components/Footer.tsx">
              <div className="flex items-center space-x-2" data-id="dmrzji10g" data-path="src/components/Footer.tsx">
                <Phone className="w-4 h-4 text-blue-400" data-id="lhxwuo1xv" data-path="src/components/Footer.tsx" />
                <span className="text-sm" data-id="x3ybbrqtm" data-path="src/components/Footer.tsx">55.6251.7774</span>
              </div>
              <div className="flex items-center space-x-2" data-id="59ohbtuga" data-path="src/components/Footer.tsx">
                <Mail className="w-4 h-4 text-blue-400" data-id="wpt7gxoif" data-path="src/components/Footer.tsx" />
                <span className="text-sm" data-id="8xs2xzxdj" data-path="src/components/Footer.tsx">nathan@automatiza.me</span>
              </div>
              <div className="flex items-center space-x-2" data-id="bxb98p3l5" data-path="src/components/Footer.tsx">
                <MapPin className="w-4 h-4 text-blue-400" data-id="9ulvrxd6t" data-path="src/components/Footer.tsx" />
                <span className="text-sm" data-id="jq0hrrqkn" data-path="src/components/Footer.tsx">Ciudad de México, México</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="bbke9t5ee" data-path="src/components/Footer.tsx">
            <h4 className="text-xl font-semibold mb-4" data-id="4qlus1h0x" data-path="src/components/Footer.tsx">Enlaces Rápidos</h4>
            <ul className="space-y-2" data-id="5kj0sac3e" data-path="src/components/Footer.tsx">
              {quickLinks.map((link, index) =>
              <li key={index} data-id="fhgdq94ek" data-path="src/components/Footer.tsx">
                  <a
                  href={link.href}
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                  target={link.href.startsWith('http') ? '_blank' : '_self'}
                  rel={link.href.startsWith('http') ? 'noopener noreferrer' : ''} data-id="nfxjdvuwx" data-path="src/components/Footer.tsx">

                    {link.name}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Services */}
          <div data-id="0wxjwcs77" data-path="src/components/Footer.tsx">
            <h4 className="text-xl font-semibold mb-4" data-id="r9x0deha3" data-path="src/components/Footer.tsx">Servicios</h4>
            <ul className="space-y-2" data-id="jmonuau13" data-path="src/components/Footer.tsx">
              {services.map((service, index) =>
              <li key={index} data-id="ye8dpj5o1" data-path="src/components/Footer.tsx">
                  <span className="text-gray-300 text-sm" data-id="21rdwnb8u" data-path="src/components/Footer.tsx">{service}</span>
                </li>
              )}
            </ul>
          </div>

          {/* Brands & Social */}
          <div data-id="wc00vlli8" data-path="src/components/Footer.tsx">
            <h4 className="text-xl font-semibold mb-4" data-id="2i6500vk6" data-path="src/components/Footer.tsx">Marcas que Manejamos</h4>
            <div className="grid grid-cols-2 gap-2 mb-6" data-id="c5beyrego" data-path="src/components/Footer.tsx">
              {brands.map((brand, index) =>
              <div key={index} className="text-gray-300 text-sm" data-id="w8l2zkst2" data-path="src/components/Footer.tsx">
                  {brand}
                </div>
              )}
            </div>
            
            <h4 className="text-xl font-semibold mb-4" data-id="0lnq7b3mt" data-path="src/components/Footer.tsx">Síguenos</h4>
            <div className="flex space-x-4" data-id="xj6ue9ej4" data-path="src/components/Footer.tsx">
              {socialLinks.map((social, index) =>
              <a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-700 hover:bg-blue-600 p-2 rounded-lg transition-colors duration-200"
                aria-label={social.name} data-id="k2tfn3xgo" data-path="src/components/Footer.tsx">
                  {social.icon}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 py-8" data-id="hjwcaam44" data-path="src/components/Footer.tsx">
        <div className="container mx-auto px-4 text-center" data-id="s9qkpb3gm" data-path="src/components/Footer.tsx">
          <h3 className="text-2xl font-bold mb-2" data-id="cks5tv5v5" data-path="src/components/Footer.tsx">¿Quieres Mantenerte Actualizado?</h3>
          <p className="text-blue-100 mb-4" data-id="fdk7r5o6o" data-path="src/components/Footer.tsx">
            Suscríbete a nuestro newsletter y recibe las últimas novedades en automatización del hogar.
          </p>
          <div className="flex flex-col sm:flex-row max-w-md mx-auto gap-4" data-id="63oz5nm6c" data-path="src/components/Footer.tsx">
            <input
              type="email"
              placeholder="Tu email"
              className="flex-1 px-4 py-2 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-white" data-id="ab3kuwsev" data-path="src/components/Footer.tsx" />
            <button className="bg-white text-blue-600 px-6 py-2 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="tvrrfeb9k" data-path="src/components/Footer.tsx">
              Suscribirme
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-gray-900 border-t border-gray-700 py-6" data-id="53cdccpf1" data-path="src/components/Footer.tsx">
        <div className="container mx-auto px-4" data-id="8i2rre7ut" data-path="src/components/Footer.tsx">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="rg8vbhrmx" data-path="src/components/Footer.tsx">
            <div className="text-center md:text-left" data-id="82i7e87wr" data-path="src/components/Footer.tsx">
              <p className="text-gray-400 text-sm" data-id="16wipa212" data-path="src/components/Footer.tsx">
                © {currentYear} Automatiza.me. Todos los derechos reservados.
              </p>
            </div>
            <div className="flex flex-wrap justify-center md:justify-end space-x-6" data-id="n7blbv6js" data-path="src/components/Footer.tsx">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="l6a9ata5g" data-path="src/components/Footer.tsx">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="i7kf014y8" data-path="src/components/Footer.tsx">
                Términos y Condiciones
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="fe2rlsy7s" data-path="src/components/Footer.tsx">
                Aviso Legal
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Certifications */}
      <div className="bg-gray-800 border-t border-gray-700 py-4" data-id="e4ddt36hk" data-path="src/components/Footer.tsx">
        <div className="container mx-auto px-4 text-center" data-id="cc8k11how" data-path="src/components/Footer.tsx">
          <p className="text-gray-400 text-xs" data-id="ml65jsq6n" data-path="src/components/Footer.tsx">
            Empresa certificada • Técnicos especializados • Garantía total • Servicio profesional
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;